import React from "react";
import { FiInfo } from "react-icons/fi";

interface InfoTooltipProps {
  id: string;
  text: string;
  onVisibleChange?: (id: string | null) => void;
  visibleId?: string | null;
}

export function InfoTooltip({
  id,
  text,
  onVisibleChange,
  visibleId,
}: InfoTooltipProps) {
  const [internalVisible, setInternalVisible] = React.useState<string | null>(
    null,
  );

  const effectiveVisibleId =
    visibleId !== undefined ? visibleId : internalVisible;

  const setVisible = (value: string | null) => {
    if (onVisibleChange) {
      onVisibleChange(value);
    } else {
      setInternalVisible(value);
    }
  };

  return (
    <div className="relative inline-block">
      <button
        type="button"
        onMouseEnter={() => setVisible(id)}
        onMouseLeave={() => setVisible(null)}
        onClick={(e) => {
          e.stopPropagation();
          setVisible(effectiveVisibleId === id ? null : id);
        }}
        className="ml-2 inline-flex items-center justify-center rounded-full text-gray-400 transition hover:text-purple-600 dark:hover:text-purple-400"
      >
        <FiInfo size={16} />
      </button>
      {effectiveVisibleId === id && (
        <div className="absolute left-0 top-6 z-50 w-64 rounded-lg border border-stroke bg-white p-3 text-xs leading-relaxed text-gray-600 shadow-lg dark:border-strokedark dark:bg-boxdark dark:text-gray-300">
          {text}
          <div className="absolute -top-1 left-4 h-2 w-2 rotate-45 border-l border-t border-stroke bg-white dark:border-strokedark dark:bg-boxdark" />
        </div>
      )}
    </div>
  );
}

